/**
 * Created by Administrador on 3/24/2017.
 */
(function(){
    'use strict';

    var seatOptions = {
        templateUrl: 'app/components/seatMap/seat-options.html',
        controller: seatOptionsController,
        controllerAs: 'vm',
        bindings:{
            seat: '=',
            seatIndex: '=',
            seatContainer: '@',
            cabinIndex: '=',
            categoryCode: '@',
            onUpdateSeat: '&',
            onEditSeat: '&',
            onDeleteSeat: '&'
        }
    }

    angular
        .module('completeAir')
        .component('seatOptions', seatOptions);

    seatOptionsController.$inject = ['$element'];

    function seatOptionsController($element){
        var vm = this;
        var elemJQLegend = $element.find("div.seat");
        vm.seatCatgory = null;

        vm.$onInit = function(){}

        vm.$postLink = function(){

            var $drag = elemJQLegend.draggable({
                containment: "#" + vm.seatContainer + vm.cabinIndex,
                grid: [1, 1]
            });

            $drag.on( "dragstop", function( event, ui ) {
                vm.seat.left = ui.position.left;
                vm.seat.top = ui.position.top;
                vm.onUpdateSeat({indexSeat: vm.seatIndex, indexCabin: vm.cabinIndex, seat: vm.seat});
            });
        }

        vm.editCabinToSeat = function(){
            vm.onEditSeat({indexSeat: vm.seatIndex, indexCabin: vm.cabinIndex, header: vm.seat.headerSeat});
        }

        vm.deleteCabinToSeat = function(){
            vm.onDeleteSeat({indexSeat: vm.seatIndex, indexCabin: vm.cabinIndex, header: vm.seat.headerSeat});
        }
    }

})();
